// extracted by mini-css-extract-plugin
export default {"tips":"Tip-module__tips___3rf-O","percent":"Tip-module__percent___TMpmI","dollars":"Tip-module__dollars___m+IF1"};